import * as React from 'react';
import { Box } from 'theme-ui';
import GlobalStyle from '../GlobalStyle';

const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <>
    <GlobalStyle />
    <Box
      as="main"
      sx={{
        height: '100vh',
        '@supports (height: 100dvh)': { height: '100dvh' },
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bg: 'background',
        color: 'primaryText',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          minHeight: 0,
          width: '100%',
          // Fixed px: the outer frame stays put while the content scales with the size preference.
          px: ['16px', '24px'],
          py: ['8px', '24px'],
        }}
      >
        {children}
      </Box>
    </Box>
  </>
);

export default Layout;
